import { isNullOrUndefined } from 'util';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { delay } from 'q';
import * as d3 from 'd3';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertDataService } from '../../side-bar/alert/alert-data.service';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-alert-play-progress-bar',
  templateUrl: './alert-play-progress-bar.component.html',
  styleUrls: ['./alert-play-progress-bar.component.scss']
})
export class AlertPlayProgressBarComponent implements OnInit {

  styleObjforBottomBar: {};
  playpause: boolean;
  state = 'stop';
  playWidth: any = 3;
  startIndex: any = 0;
  childStartIndex:any = 0
  bottomBarMenuSelectedIndex = 0;
  bottomBarMenuSelectedChildIndex = 0;
  oldPlayButton: any;
  playBetweenIndex: any = 0;
  forecastLengthSubscription: any;
  playButtonSubscription:any;
  positionSubscription:any;
  forecastLength: any;
  currentIndex: any = 0;
  urlparams: any;
  routeSections: string[] = [];
  playPos: any=0;
  isChange: boolean=false;
  currentpos: any=0;
  format: any;
  selectedValue=0;
  constructor(private route: ActivatedRoute, private utils: AlertDataService,private router: Router) {
    this.forecastLengthSubscription = this.route.params.subscribe(routeParams => {
      const forecastLength = routeParams.time;
      if (forecastLength != this.forecastLength) {
        this.forecastLength = routeParams.time;
        this.bottomBarMenuSelectedIndex = 0;
        this.styleObjforBottomBar = { width: 0 };
      }
    });
    this.styleObjforBottomBar = { width: 0 };
  }

  @Input() playButtonDisable: boolean;
  @Input() labelStrings: any;
  @Input() inflowLocClicked: any;
  // @Input() playPosition: number;
  @Output() groupSelected = new EventEmitter<any>();
  @Input() sourceSelected:any;
  @Input() activeSideMenu:any

  value: number = 0;
  options: Options = {
    showTicksValues: false,
    hideLimitLabels:true,
    showSelectionBar:true,
    hidePointerLabels:true,
    stepsArray: [],
  };
  ngOnInit() {
   
    this.playButtonSubscription = this.utils.getPlayButton().subscribe(playPosition => {
      console.log(playPosition)
      if (!isNullOrUndefined(playPosition) && !isNullOrUndefined(playPosition)) {
        this.playPos = playPosition;
        this.value=playPosition
        // if(this.value!=0)
        // {
        //   this.isChange=true;
        // }

        console.log(playPosition,this.labelStrings)
        if(this.forecastLength && playPosition){
          this.changeStartIndex(playPosition);
        }
      }
      this.urlparams = this.getCurrentUrlParams();
      this.changebutton();
      if (this.playButtonDisable == true) {
        // this.oldPlayButton = this.playButtonDisable;
        this.styleObjforBottomBar = { width: 0 };
        this.state = 'stop';
        this.playWidth = 3;
        this.startIndex = 0;
        this.childStartIndex = 0
        this.currentIndex = 0;
        this.playBetweenIndex = 0;
        this.bottomBarMenuSelectedIndex = 0;
        this.changebutton();
      }
      if (this.labelStrings.length > 0) {
        const i = this.bottomBarMenuSelectedIndex;
        const width = ((i) * (100 / (this.labelStrings.length - 1)));
        this.styleObjforBottomBar = { width: width.toString() + '%' };
      }
    })
    this.positionSubscription=this.utils.getDefaultPlayPosition().subscribe(value=>{
      this.isChange=value;
      console.log(value)
      this.selectedValue=this.isChange?this.playPos:-1;
    })
    // this.labelStrings.forEach((value,index)=>{
    //   let obj:any={'value':Number,'legend':String}
    //   obj['value']=index;
    //   obj['legend']=value.label.label;
    //   this.options.stepsArray.push(obj);
    // })
    // if(!this.isChange)
    // {
    //    this.value=this.labelStrings.length-1;
    //    console.log(this.value)
    // }
    console.log(this.labelStrings,this.options.stepsArray);
  }
  onClick(event)
  {
    console.log("change startindex from click",event)
    this.changeStartIndex(event);
  }
  ngOnDestroy() {
    if(!isNullOrUndefined(this.forecastLengthSubscription)){
      this.forecastLengthSubscription.unsubscribe();
    }
    if(!isNullOrUndefined(this.playButtonSubscription)){
      this.playButtonSubscription.unsubscribe();
    }
    if(!isNullOrUndefined(this.positionSubscription))
    {
      this.positionSubscription.unsubscribe();
    }
    this.utils.setDefaultPlayPosition(false);
  }

  ngOnChanges(change: SimpleChanges) {    
    // if(change.labelStrings){
    //   if (this.labelStrings[this.playPos]) {
    //     console.log("gw groupSelected emitted hell : ",)
    //     this.groupSelected.emit(this.labelStrings[this.playPos]['groupName']);
    //   }
    // }
    if(this.inflowLocClicked && this.state != 'pause' && this.state != 'stop'){
      this.animate();
    }else{
      if(change.labelStrings || change.sourceSelected){
        this.state='stop';
          this.changebutton();
          if(this.labelStrings.length>5){
            this.changeStartIndex(0)
          }

      }
      if(change.labelStrings)
        {
        this.options = {...this.options}
        this.options.stepsArray=[];
        console.log(change.labelStrings,change.value)
        console.log("stesparay",this.options.stepsArray,change.labelStrings.currentValue,this.value)
        change.labelStrings.currentValue.forEach((value,index)=>{
          // console.log(change.stepsArray.currentValue)
          let obj:any={'value':Number,'legend':String}
          obj['value']=index;
          obj['legend']=value.label.label;
          console.log(obj)
          this.options.stepsArray.push(obj);
        })
        // this.manualRefresh.emit();
        console.log("ischange",this.isChange)
        this.format=this.labelStrings&&this.labelStrings[0]&& this.labelStrings[0].label&&this.labelStrings[0].label.label?this.getLabelFormat(this.labelStrings[0].label.label):'- - - -';
      }
    }    
  }

  getValue()
  {
    if(this.isChange)
    {
      return  this.value;
    }
    else 
     return -1;
  }

  setValue(event)
  {
    console.log(event)
    if(event==0)
    {
      this.groupSelected.emit(this.labelStrings[event]['groupName']);
    }
    else
    this.value=event;
    // this.changeStartIndex(value);
  }

  getLabelFormat(labelString)
  {
    let dates,format;
    if(labelString.includes('/'))
    {
     dates=labelString.split('/');
      if(dates.length==3)
       format='- -/- -/- - - -';
      else if(dates.length==2)
       format='- -/- - - -';
    }
    else if(labelString.includes(':'))
    {
      dates= labelString.split(':');
      if(dates.length==2)
       format='- -:- -';
      else if(dates.length==3)
       format='- -:- -:- -'
    }
    else 
    {
      format='- - - -';
    }
    return format;
  }

  async animate() {
    this.changebutton();
    this.playpause = !this.playpause;
    /*This if written for the condition when width is 100 and user clicks play button*/
    if (this.state == 'play' || this.state == 'resume') {
      this.state = 'pause';
      this.changebutton();
      return;
    }

    if (this.state == 'stop') {
      const width = 0;
      this.playWidth = 12 / (this.labelStrings.length - 1);
      this.styleObjforBottomBar = { width: width.toString() };
      // this.groupSelected.emit(this.labelStrings[0]['groupName']);
      this.bottomBarMenuSelectedIndex = 0;
      this.state = 'play';
      this.changebutton();
    } else if (this.state == 'pause') {
      this.state = 'play';
      this.changebutton();
    }
    for (let index = this.startIndex; index <= this.labelStrings.length; index++) {
      this.currentIndex = index;
      this.value=index;
      if ((this.state === 'play' || this.state === 'resume')) {

        // let width = this.playWidth;
        if (index >= this.labelStrings.length) {
          this.startIndex = 0;
          this.currentIndex = 0;
          index = -1;
          this.playWidth = 0;
          this.playBetweenIndex = 0;
          const width = 0;
          this.styleObjforBottomBar = { width: width.toString() + '%' };
          await delay(1000);
          continue;
        }
        console.log("value",this.value,"index",index)
        if(isNullOrUndefined(this.labelStrings[index]['children'])) {
          console.log("PARENT ENTER1234",this.labelStrings[index]['groupName']);
          
          this.groupSelected.emit(this.labelStrings[index]['groupName']);
        } else if(!isNullOrUndefined(this.labelStrings[index]['children']) && this.labelStrings[index]['children'].length > 0 && !this.labelStrings[index]['isMerged']){
          for (let childIndex = this.childStartIndex; childIndex <= this.labelStrings[index]['children'].length; childIndex++) {
            if(this.state === 'play') {
              if(childIndex < this.labelStrings[index]['children'].length) {
              console.log("ENTERING CHILDDD1234",this.labelStrings[index]['children'][childIndex]['groupName'],this.state);
              this.childStartIndex = childIndex
              this.bottomBarMenuSelectedIndex = index;
              this.bottomBarMenuSelectedChildIndex = childIndex
            this.groupSelected.emit(this.labelStrings[index]['children'][childIndex]['groupName']);
            await delay(2000);
            }
            else {
              console.log("END IF CHILD");
              // childIndex = -1
              this.childStartIndex = 0;
              this.bottomBarMenuSelectedChildIndex = -1
              break;
            }
          } else {
            this.childStartIndex = childIndex
            break;
          } 
        }
        }
        this.isChange=true;
        this.selectedValue=index;
        this.bottomBarMenuSelectedIndex = index;
        let i = this.playBetweenIndex;
        while (i <= 30) {
          if (this.state === 'play' || this.state === 'resume') {
            const width = ((index) * (100 / (this.labelStrings.length - 1))) + (i * ((100 / (this.labelStrings.length - 1)) / 30)) + (2.5 - ((this.labelStrings.length - 5) / 12));
            const num = 6;
            this.styleObjforBottomBar = { width: width.toString() + '%', transition: num.toString() + 's' + 'ease' };
            console.log("play",this.labelStrings.length)
            await delay(100);
          } else {
            console.log("not play")
            this.startIndex = index;
            this.currentIndex = index;
            this.playBetweenIndex = i;
            return;
          }
          i++;
          if (index != this.currentIndex) {
            i = -10;
            index = this.currentIndex;
          }
        }
        this.playBetweenIndex = 0;
        if (index === this.labelStrings.length) {
          this.startIndex = 0;
          this.currentIndex = 0;
          index = -1;
          this.playWidth = 0;
          this.playBetweenIndex = 0;
          const width = 0;
          this.styleObjforBottomBar = { width: width.toString() + '%' };
          await delay(1000);
          continue;
          // this.changebutton();
        }
        await delay(100);
      } else {
        if (index < this.labelStrings.length) {
          this.startIndex = index;
          this.currentIndex = index;
          this.state = 'pause';
        } else {
          this.startIndex = 1;
          this.currentIndex = 1;
          this.state = 'pause';
        }
        break;
      }
    }
  }

  collapseNowcastBar(i) {
    if(this.labelStrings[i]['fullLabel'] == 'Grouped Nowcast' && !this.labelStrings[i]['isMerged']) {
      this.labelStrings[i]['isMerged'] = true
      if(this.startIndex == i) {
        this.groupSelected.emit(this.labelStrings[i]['groupName'])
      }
    }
  }

  changeStartIndex(i) {
    
    this.currentpos=i;
    console.log("this.currentpos",this.currentpos,this.labelStrings[i]['isMerged']);
    this.selectedValue=i;
    if (i == this.currentIndex) {
      return;
    }
    
    this.startIndex = i;
    this.currentIndex = i;
    this.bottomBarMenuSelectedIndex = i;
    this.bottomBarMenuSelectedChildIndex = -1
    this.playBetweenIndex = 0;
    this.childStartIndex = 0
    const width = ((i) * (100 / (this.labelStrings.length - 1)));
    this.styleObjforBottomBar = { width: width.toString() + '%' };
    if (this.labelStrings[i]) {
      console.log("change",i,this.labelStrings[i])
      this.groupSelected.emit(this.labelStrings[i]['groupName']);
      this.isChange=true;
      if(this.labelStrings[i]['fullLabel'] == 'Grouped Nowcast' && this.labelStrings[i]['isMerged']) {
        this.labelStrings[i]['isMerged'] = false
        this.childStartIndex = 0
      }
    }
  }

  changeChildStartIndex(i,j) {
    if (j == this.childStartIndex) {
      return;
    }
    this.startIndex = i
    this.currentIndex = i;
    this.bottomBarMenuSelectedIndex = i;
    this.childStartIndex = j;
    this.bottomBarMenuSelectedChildIndex = j;
    if (this.labelStrings[i]) {
      console.log("change",i,this.labelStrings[i],this.labelStrings[i]['children'][j]['groupName'])
      this.groupSelected.emit(this.labelStrings[i]['children'][j]['groupName']);
      // this.isChange=true;
      // if(this.labelStrings[i]['fullLabel'] == 'Grouped Nowcast' && this.labelStrings[i]['isMerged']) {
      //   this.labelStrings[i]['isMerged'] = false
      // }
    }
  }

  changebutton() {
    if (this.state == 'play' || this.state == 'resume') {
      d3.select('#button_play i').attr('class', 'fa fa-pause');
    } else {
      d3.select('#button_play i').attr('class', 'fa fa-play');
    }

  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['label'];
    }
  }

  getToolTipValue(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['toolTip'];
    }
  }

  getCurrentUrlParams() {
    const obj = this.route.snapshot.params;
    this.routeSections = this.router.url.split('/');
    if (obj == null || obj == undefined) { return obj; }
    // if (this.routeSections[2] === 'extremeweather' && this.routeSections[3] === 'rainfall' &&
    //   this.routeSections[4] === '24') {
    //   if (Object.keys(this.labelStrings).length === 5) {
    //     const i = Object.keys(this.labelStrings).length - 1;
    //     this.startIndex = i;
    //     this.currentIndex = i;
    //     this.bottomBarMenuSelectedIndex = i;
    //     this.playBetweenIndex = 0;
    //     this.groupSelected.emit(this.labelStrings[i]['groupName']);
    //   }
    // }
    const objectConfig = {};
    for (const key in obj) {
      objectConfig[key] = obj[key];
    }    
    return objectConfig;
  }

  showtooltipval() {
    if (this.urlparams['time']) {
      return true;
    }
    if ((this.urlparams['component'] == 'groundwater'  && this.urlparams['dashboard'] == 'waterSupply') || this.urlparams['component'] == 'inflowForecast'  || this.urlparams['component'] == 'rainfall' || this.urlparams['component'] == 'projectdashboard') {
      return true;
    }
    if((this.router.url).includes('rainfallnowcast'))
    {
      return true;
    }
    return false;
  }

  onPrev(index)
  {
    this.value=index-1;
  }

  onNext(index)
  {
    console.log("value",index)
    this.value=index+1;
  }

  formatDate(dateString: string): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
    // Split the input date into day, month, and year
    const [day, month, year] = dateString.split("/");
  
    // Convert the month to its short name
    const monthName = months[parseInt(month, 10) - 1];
  
    // Return the formatted date
    return `${day}-${monthName}-${year}`;
  }
  // changebutton() {
  //   console.log(this.state);
  //   if (this.state === 'stop') {
  //     this.state = 'play';
  //     let button = d3.select('#button_play').classed('btn-success', true);
  //     button.select('i').attr('class', 'fa fa-play');
  //   } else if (this.state == 'play' || this.state == 'resume') {
  //     this.state = 'pause';
  //     d3.select('#button_play i').attr('class', 'fa fa-play');
  //   } else if (this.state == 'pause') {
  //     this.state = 'resume';
  //     d3.select('#button_play i').attr('class', 'fa fa-pause');
  //   } else if(this.state === 'end'){
  //     this.state = 'stop';
  //     d3.select('#button_play i').attr('class', 'fa fa-play');
  //   }

  //   console.log(this.state);
  // }

}
